import { render, staticRenderFns } from "./AudioPlayerProgressBar.vue?vue&type=template&id=16979d4a&scoped=true&"
import script from "./AudioPlayerProgressBar.vue?vue&type=script&lang=ts&"
export * from "./AudioPlayerProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./AudioPlayerProgressBar.vue?vue&type=style&index=0&id=16979d4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16979d4a",
  null
  
)

export default component.exports